// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CaseNasushiobara() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>ウールとワインと那須塩原のWA！</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>地域創生</span>
            <span>ブロックチェーン事業開発</span>
          </div>
          <h1 className="cd-title">
            ウール肥料で育てたワインを、NFTの引換券で届ける「ウールとワインと那須塩原のWA！」
          </h1>
          <p className="cd-client">株式会社Spicelink・那須塩原市</p>
          <div className="cd-img">
            <img src="/assets/images/case-nasushiobara.jpg" alt="" />
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                地域でつくるワインを、事前に支援してくれる人へ確実に届けたい。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>
                NFTをワインの引換券にし、メールアドレスだけで持てる仕組みを実装。
              </p>
            </div>
            <div>
              <span>成果</span>
              <p>
                Web3に慣れていない人も参加できる、地域連携のメンバーシップを実現。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              サステナブルアパレルブランド「PIZZA
              DAY」と那須塩原市が共創した、ウール製品からつくった肥料でブドウを育てる「サーキュラーワイン」のプロジェクトです。購入者は「ワイン引換券」となるNFTを持ち、翌夏にワインと交換できます。
            </p>
          </section>
          <section className="cd-sec">
            <h2>お客様の課題</h2>
            <ul className="cd-list">
              <li>
                ワインが完成する前から、プロジェクトを応援してくれる人を集めたかった
              </li>
              <li>
                酒類の販売方法に配慮しながら、購入者にワインを届ける仕組みが必要だった
              </li>
              <li>暗号資産やNFTに慣れていない人にも参加してほしかった</li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSの対応</h2>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">NFT引換券</p>
                <h3 className="cd-ptitle">ワインと交換できるNFTの設計</h3>
                <p>
                  NFTを「ワイン引換券」とし、購入者が翌夏にワインと交換できる、リアルの資産と結びついたメンバーシップNFTとして設計しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">MPCウォレット</p>
                <h3 className="cd-ptitle">メールアドレスだけで持てるNFT</h3>
                <p>
                  秘密鍵の管理が不要で、メールアドレスだけでNFTを持てるウォレットを導入し、Web3に慣れていない人でも参加できる形にしました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">参加型体験</p>
                <h3 className="cd-ptitle">ワインが育つ過程を一緒に</h3>
                <p>
                  収穫イベントやオンライン配信など、ワインが育つ過程をNFTの保有者が体験できる仕組みを設計しました。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>成果</h2>
            <p>
              アパレル・農業・地域をつなぐサーキュラーなプロジェクトに、ブロックチェーンを使った新しい参加と応援の形を取り入れました。
            </p>
          </section>
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/premience">
              <div className="case-img">
                <img src="/assets/images/case-premience.jpg" alt="" />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
              </h3>
              <div className="case-tags">
                <span>旅行・観光</span>
                <span>ブランディング・Web制作</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
